var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2312",
    "data-name": "Rectangle 2312",
    width: 35,
    height: 35,
    fill: "#101b2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10306",
    "data-name": "Group 10306",
    transform: "translate(0.252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10305",
    "data-name": "Group 10305",
    transform: "translate(-0.252)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28395",
    "data-name": "Path 28395",
    d: "M33.348,16.1H28.174V12.613a.778.778,0,0,0,0-.12.566.566,0,0,0,0-.1.663.663,0,0,0,0-.11,1,1,0,0,0-.039-.1l-.117-.105c-.018-.033-.036-.063-.057-.093l-.069-.087-.081-.084-.074-.063-.1-.074H27.6L18.4,6.244V5.175h2.875a1.15,1.15,0,0,0,1.15-1.15V1.15A1.15,1.15,0,0,0,21.274,0H17.249A1.15,1.15,0,0,0,16.1,1.15V6.244L6.9,11.661H6.87l-.1.075-.075.063-.08.087-.069.084a.578.578,0,0,0-.057.093l-.054.1c-.015.033-.028.069-.039.1a.673.673,0,0,0,0,.111.558.558,0,0,0,0,.1.829.829,0,0,0,0,.123v3.483H1.15A1.15,1.15,0,0,0,0,17.232V33.348A1.15,1.15,0,0,0,1.15,34.5h32.2a1.15,1.15,0,0,0,1.15-1.15v-16.1a1.15,1.15,0,0,0-1.15-1.15M18.4,2.3h1.725v.575H18.4ZM32.2,21.274H28.174V18.4H32.2ZM6.325,18.4v2.875h-2.3a1.15,1.15,0,0,0,0,2.3h2.3v2.875H2.3V18.4ZM2.3,28.749H6.325V32.2H2.3Zm6.325-11.5V13.3l8.625-5.073L25.874,13.3V32.2H8.625ZM28.174,32.2v-3.45h2.3a1.15,1.15,0,1,0,0-2.3h-2.3V23.574H32.2V32.2ZM10.924,13.8a1.15,1.15,0,0,1,1.15-1.15H22.424a1.15,1.15,0,1,1,0,2.3H12.074a1.15,1.15,0,0,1-1.15-1.15m4.6,3.45H11.5a1.15,1.15,0,0,0-1.15,1.15v4.025a1.15,1.15,0,0,0,1.15,1.15h4.025a1.15,1.15,0,0,0,1.15-1.15V18.4a1.15,1.15,0,0,0-1.15-1.15m-1.15,4.025H12.649V19.549h1.725Zm1.15,3.45H11.5a1.15,1.15,0,0,0-1.15,1.15V29.9a1.15,1.15,0,0,0,1.15,1.15h4.025a1.15,1.15,0,0,0,1.15-1.15V25.874a1.15,1.15,0,0,0-1.15-1.15m-1.15,4.025H12.649V27.024h1.725ZM23,17.249H18.974a1.15,1.15,0,0,0-1.15,1.15v4.025a1.15,1.15,0,0,0,1.15,1.15H23a1.15,1.15,0,0,0,1.15-1.15V18.4A1.15,1.15,0,0,0,23,17.249m-1.15,4.025H20.124V19.549h1.725ZM23,24.724H18.974a1.15,1.15,0,0,0-1.15,1.15V29.9a1.15,1.15,0,0,0,1.15,1.15H23a1.15,1.15,0,0,0,1.15-1.15V25.874A1.15,1.15,0,0,0,23,24.724m-1.15,4.025H20.124V27.024h1.725Z",
    transform: "translate(0.219)",
    fill: "#101b2d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon5);
export default __webpack_public_path__ + "static/media/social_icon5.7bbc47c955a3fba12a25344f96e11bc2.svg";
export { ForwardRef as ReactComponent };